import { EMPTY } from 'rxjs';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { catchError, map } from 'rxjs/operators';
import { of } from "rxjs/observable/of";

import { ExtendedHttpResponse, HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import { IDocument } from "@ispm/migration/interfaces/report-and-document.interface";
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import {BrowserCacheService} from "@ispm/core/services/browser-cache.service";

@Injectable()
export class AttachmentService {

  public readonly baseUrl = '/reportsAndDocuments';
  public open = false;
  public editModeIsSupported = true;
  public activeAction: any = null;
  public maxUploadedFile: number = 0;
  public maxFilesize: number = 0;

  constructor(
    private http: HttpInterceptorService,
    private store: Store<IgenomicsState>,
    private browserCacheService: BrowserCacheService
  ) {
  }

  public postToEmr(workflowId: string, revisionId: string, file: IDocument): Observable<ExtendedHttpResponse<any>> {
    const data = {
      workflowId: workflowId,
      revisionId: revisionId,
      fileId: file.id
    };

    return this.http.post(
      '/report/sendToEmr',
      data,
      true,
      {
        'Content-Type': 'application/json'
      }
    );
  }

  public getDocuments(revisionId: string,enableCache:boolean = false,addClientTime: boolean = false): Observable<any> {
    let newTest = false;
    const currOrderSubs = this.store.select('currentOrder')
      .subscribe(currentOrderDetails => newTest = currentOrderDetails && currentOrderDetails.isNewOrder);

    if (currOrderSubs) {
      currOrderSubs.unsubscribe();
    }

    if (newTest && revisionId.indexOf('commonDocument') === -1) {
      const emptyDocumentData = {
        body: {
          data: []
        }
      };

      return of(emptyDocumentData);
    }
    let params = { context: revisionId, addClientTime };
    if(enableCache){
      params['cacheId'] = this.browserCacheService.getCacheId();
    }
    return this.http.get(this.baseUrl, params);
  }

  public toggleAttachments(editModeIsSupported?: any): void {
    this.editModeIsSupported = editModeIsSupported !== undefined ? editModeIsSupported : true;
    this.open = !this.open;
    this.activeAction = null;
  }

  public collapseAttachments(): void {
    if (this.open) {
      this.toggleAttachments();
    }
  }

  public getMaxUploadedFilesAllowedPerTest(): Observable<ExtendedHttpResponse<any>> {
    return this.http.get(this.baseUrl + '/getMaxUploadedFilesAllowedPerTest');
  }

  public getMaxFileSizeAllowedForUpload(): Observable<ExtendedHttpResponse<any>> {
    return this.http.get(this.baseUrl + '/getMaxFileSizeAllowedForUpload');
  }

  public addOrganizationToFileContext(fileId: string, organizationId: string, revisionId: string): Observable<ExtendedHttpResponse<any>> {
    return this.http.get(this.baseUrl + `/addOrganizationToFileContext/${fileId}/${organizationId}/${revisionId}`);
  }

  public removeOrganizationToFileContext(fileId: string, organizationId: string, revisionId: string): Observable<ExtendedHttpResponse<any>> {
    return this.http.get(this.baseUrl + `/removeOrganizationFromFileContext/${fileId}/${organizationId}/${revisionId}`);
  }

  public generateDownloadURL(fileId: string): Observable<any> {
    return this.http.get(this.baseUrl + '/generateDownloadURL/' + fileId).pipe(
      map(res => res.body),
      catchError(() => {
        return EMPTY;
      })
    )
  }

  public deleteUploadedFile(fileId: string): Observable<any> {
    return this.http.get(this.baseUrl + `/deleteUploadedFile/${fileId}`);
  }
}
